
import React, { memo } from 'react';

import { Icon } from '../../../icons';

type Props = {

  /**
   * The decorated component (ToolboxButton).
   */
  children: React$Node,

  /**
   * Icon of the button.
   */
  icon: Function,

  /**
   * Flag used for disabling the small icon.
   */
  iconDisabled: boolean,

  /**
   * Click handler for the small icon.
   */
  onIconClick: Function,

  /**
   * The tooltip used for the icon.
   */
  iconTooltip: string,

  /**
   * Additional styles.
   */
  styles?: Object,
};

/**
 * Displays the `ToolboxButtonWithIcon` component.
 *
 * @param {Object} props - Component's props.
 * @returns {ReactElement}
 */
const ToolboxButtonWithIcon = (props: Props) => {
    const { children, icon, iconDisabled, onIconClick, styles, isFloatView }
    = props;

    const iconProps = {};

    if (iconDisabled) {
        iconProps.className
      = 'settings-button-small-icon settings-button-small-icon--disabled';
    } else {
        iconProps.className = 'settings-button-small-icon';

        // iconProps.onClick = onIconClick;
    }

    return (
        <div
            className = { isFloatView ? 'settings-button-container float-view' : 'settings-button-container' }
            style = { styles }>
            {children}

            <div onClick = { onIconClick }>
                <Icon
                    { ...iconProps }
                    size = { 9 }
                    src = { icon } />
            </div>
        </div>
    );
};

export default memo(ToolboxButtonWithIcon);
